module.exports = __webpack_public_path__ + "img/logoZZG.9a35daec.svg";